import { Spinner as ReactSpinner } from "react-bootstrap";

export const Spinner = () => {
  return (
    <div className="spinner text-center">
      <ReactSpinner animation="border" />
    </div>
  );
};
